import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

export const downloadACHAuthorizationRecord = async (bankId) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/payment/admin/account/payment-method/authorization-record/${bankId}`,
    {
      headers,
      responseType: 'blob',
    },
  );

  return response.data;
};
